module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/catalogo-inversionistas/catalogo-inversionistas.component.scss
// module id = ./src/app/components/catalogo-inversionistas/catalogo-inversionistas.component.scss
// module chunks = main